import { watch } from '@vue/composition-api';

export function tradeFormStateHelper(props, formState, emit) {
  if (Array.isArray(formState.value)) {
    formState.value = [...formState.value, ...props.initialData];
  } else if (typeof formState.value === 'object') {
    formState.value = { ...formState.value, ...props.initialData };
  }
  watch(
    formState,
    (newVal) => {
      emit('change', newVal);
    },
    { deep: true }
  );
}
